import React, { useState, useEffect } from 'react';
import './ModernHome.css';

const WORDS = [
  "Quality", "Professionalism", "Creativity", "Luxury",
  "Innovation", "Storytelling", "Elegance", "Precision",
  "Dedication", "Excellence"
];

const CATEGORY_DATA = {
  family: {
    thumbs: [
      { id: 'wedding', title: 'Wedding', image: '/images/Website first page Family/Nikhil_01149_Wedding.jpg' },
      { id: 'upanayan', title: 'Upanayan', image: '/images/Website first page Family/Nikhil_9343_MunjaUpanayan.jpg' },
      { id: 'kids', title: 'Kids', image: '/images/Website first page Family/_NIK6394_BabyOrChildPhoto.JPG' },
      { id: 'birthday', title: 'Birthday', image: '/images/Website first page Family/Nikhil_5708_Birthday.jpg' },
      { id: 'engagement', title: 'Engagement', image: '/images/Website first page Family/Nikhil_4302_Engagement.JPG' },
      { id: 'couple', title: 'Maternity', image: '/images/Website first page Family/IMG_6263_BabyShower.jpg' },
    ]
  },
  business: {
    thumbs: [
      { id: 'interior', title: 'Interior', image: '/images/Website first page Business/DSC03641_Interior.jpg' },
      { id: 'industrial', title: 'Industrial', image: '/images/Website first page Business/DSC_0001.jpg' },
      { id: 'corporate', title: 'Corporate', image: '/images/Website first page Business/_NIK6661_Corporate.jpg' },
      { id: 'sport', title: 'Sports', image: '/images/Website first page Business/IMG_9500_Sports.JPG' },
      { id: 'exterior', title: 'Exterior', image: '/images/Website first page Business/exterior_building.jpg' },
      { id: 'product', title: 'Product', image: '/images/Website first page Business/Product.jpg' },
      { id: 'wildlife', title: 'Wildlife', image: '/images/Website first page Business/NIK_9518_Wildlife.jpg' },
    ]
  }
};

const ModernHome = ({ onNavigate, onCategoryClick, mode, setMode }) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [activeThumbIndex, setActiveThumbIndex] = useState(0);
  const [hoveredThumbIndex, setHoveredThumbIndex] = useState(null);
  const [internalMode, setInternalMode] = useState('family');
  const activeMode = mode || internalMode;
  const activeSetMode = setMode || setInternalMode;
  const activeData = CATEGORY_DATA[activeMode];
  const displayThumbIndex = hoveredThumbIndex !== null ? hoveredThumbIndex : activeThumbIndex;

  useEffect(() => {
    const wordInterval = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % WORDS.length);
    }, 1200);

    let thumbInterval = null;
    if (hoveredThumbIndex === null) {
      thumbInterval = setInterval(() => {
        setActiveThumbIndex((prev) => (prev + 1) % activeData.thumbs.length);
      }, 2000);
    }

    return () => {
      clearInterval(wordInterval);
      if (thumbInterval) clearInterval(thumbInterval);
    };
  }, [activeMode, activeData.thumbs.length, hoveredThumbIndex]);

  return (
    <div className="mh-root">

      {/* ✅ gradient काढला — फक्त image, कोणताही dark overlay नाही */}
      {activeData.thumbs.map((thumb, idx) => (
        <div
          key={thumb.id}
          className="mh-bg"
          style={{
            backgroundImage: `url("${encodeURI(thumb.image)}")`,
            opacity: idx === displayThumbIndex ? 1 : 0,
          }}
        />
      ))}

      {/* LEFT BOX — logo काढला */}
      <div className="mh-left-box">
        <h1>We Know,</h1>
        <h2>You want<br />Great <b>Photographs</b> with</h2>
        <p className="mh-changing-word">{WORDS[currentWordIndex]}</p>
        <button className="mh-contact-btn" onClick={() => onNavigate('contact')}>
          Contact Us
        </button>
      </div>

      {/* TOP MENU */}
      <div className="mh-top-menu">
        <button
          className={`mh-top-btn ${activeMode === 'family' ? 'active' : ''}`}
          onClick={() => { activeSetMode('family'); setActiveThumbIndex(0); setHoveredThumbIndex(null); }}
        >
          Family Photography
        </button>
        <button
          className={`mh-top-btn ${activeMode === 'business' ? 'active' : ''}`}
          onClick={() => { activeSetMode('business'); setActiveThumbIndex(0); setHoveredThumbIndex(null); }}
        >
          Business Photography
        </button>
      </div>

      {/* RIGHT SIDE NAV */}
      <div className="mh-side-menu">
        <button className="mh-menu-btn" onClick={() => onNavigate('home')}>Home</button>
        <button className="mh-menu-btn" onClick={() => onNavigate('gallery')}>Gallery</button>
        <button className="mh-menu-btn" onClick={() => onNavigate('about')}>About Us</button>
      </div>

      {/* SCROLL SECTION */}
      <div className="mh-scroll-section">
        <div className="mh-scroll-text">Scroll</div>
        <div className="mh-arrow-group">
          <button className="mh-scroll-btn mh-up"
            onClick={() => window.scrollBy({ top: -window.innerHeight * 0.8, behavior: 'smooth' })}>
            ↑
          </button>
          <button className="mh-scroll-btn mh-down"
            onClick={() => window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' })}>
            ↓
          </button>
        </div>
      </div>

      {/* BOTTOM GALLERY */}
      <div className="mh-gallery-wrapper">
        <div className="mh-gallery-track">
          {activeData.thumbs.map((thumb, idx) => (
            <div
              key={thumb.id}
              className={`mh-gallery-item ${idx === activeThumbIndex ? 'large' : ''}`}
              onClick={() => { onCategoryClick(thumb); setActiveThumbIndex(idx); }}
              onMouseEnter={() => {
                setHoveredThumbIndex(idx);
                setActiveThumbIndex(idx);
              }}
              onMouseLeave={() => setHoveredThumbIndex(null)}
            >
              <img src={encodeURI(thumb.image)} alt={thumb.title} />
              <span className="mh-thumb-label">{thumb.title}</span>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default ModernHome;
